export default {
  namespace: 'roleBadge',
  en: {
    managedByExonet: 'Managed by Exonet',
  },
  nl: {
    managedByExonet: 'Beheerd door Exonet',
  },
};
